import { Database } from "lucide-react";
import { api } from "@/data/api";
import { useAsync } from "@/hooks/useAsync";
import { PageHeader, StatusBadge, DataTable, AsyncBoundary, RowsSkeleton, EmptyState } from "@/components/common";

export default function Databases() {
  const { data, loading, error } = useAsync(() => api.getDatabases());
  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader icon={Database} title="Banco de Dados" description="Inventário de bancos ainda não está configurado no Control Plane."
        breadcrumb={<><span>Aplicações</span><span>/</span><span className="text-foreground">Banco de Dados</span></>}
        actions={null} />
      <AsyncBoundary loading={loading} error={error} skeleton={<RowsSkeleton />}>
        <DataTable
          columns={[
            { key: "name", header: "Instância", render: (r) => <span className="font-medium text-foreground">{r.name}</span> },
            { key: "engine", header: "Engine", render: (r) => <span className="font-mono text-xs text-muted-foreground">{r.engine}</span> },
            { key: "server", header: "Servidor", render: (r) => <span className="font-mono text-xs">{r.server}</span> },
            { key: "size", header: "Tamanho", align: "right" },
            { key: "conns", header: "Conexões", align: "right" },
            { key: "status", header: "Status", render: (r) => <StatusBadge status={r.status} size="sm" /> },
          ]}
          rows={data} testid="databases-table" empty={<EmptyState icon={Database} title="Não configurado" description="Não há model/provider de databases conectado ao TintiCloud. Nenhum número foi estimado." />} />
      </AsyncBoundary>
    </div>
  );
}
